import { TextProps } from '@features/powerpoint';

export const textStyles: Record<string, TextProps['options']> = {
  contentSlideDefaults: {
    color: '#000000',
  },
  titleSlideDefaults: {
    color: '#FFFFFF',
  },
};

export const headerTextStyles = {
  contentSlide: {
    color: textStyles.contentSlideDefaults?.color,
    fontSize: 28,
    bold: true,
    h: 1.04,
    w: 11.82,
    x: 0.74,
    y: 0.78,
  },
  titleSlide: {
    color: textStyles.titleSlideDefaults?.color,
    fontSize: 28,
    bold: true,
    h: 1.04,
    w: 11.82,
    x: 0.74,
    y: 0.78,
  },
} as const satisfies Record<string, TextProps['options']>;
